import type { ProductSummary } from "./types";

const issueLabels: Record<string, string> = {
  missing_category: "分类缺失",
  missing_style_color: "款式/颜色缺失",
  missing_spec: "规格信息缺失",
  missing_material: "材质缺失",
  missing_price: "价格缺失",
  missing_stock: "库存缺失",
  missing_product_name: "商品名称缺失",
  missing_source_name: "货源原始名称缺失",
  missing_description: "详情描述缺失",
  missing_image: "商品图片缺失",
  missing_product_url: "货源链接缺失",
  zero_stock: "零库存",
  zero_price_requires_confirmation: "零元报价需向供应商确认",
  duplicate_name: "名称可能重复",
  ip_risk: "疑似 IP / 品牌风险",
  source_mismatch: "图文来源待核",
  source_review_pending: "货源信息待人工复核",
  supplier_name_pending_confirmation: "供应商名称待确认",
  title_truncated_to_60_chars: "标题已截断至 60 字，需复核",
  name_unresolved: "商品名待确认",
};

export function issueLabel(flag: string): string {
  if (issueLabels[flag]) return issueLabels[flag];
  if (flag.startsWith("possible_ip_term:")) {
    const term = flag.slice("possible_ip_term:".length).trim();
    return term ? `可能涉及 IP / 品牌词：${term}` : "可能涉及 IP / 品牌词";
  }
  if (flag.startsWith("safety_claim_unverified:")) {
    const claim = flag.slice("safety_claim_unverified:".length).trim();
    return claim ? `“${claim}”安全或功效表述待验证` : "安全或功效表述待验证";
  }
  if (/^[a-z0-9_:\-]+$/iu.test(flag)) return "其他数据问题，需人工复核";
  return flag;
}

export function uniqueProductIssues(product: Pick<ProductSummary, "riskFlags" | "qualityFlags">): string[] {
  return [...new Set([...product.riskFlags, ...product.qualityFlags])];
}
